// Package imports:
import React, { useContext, useEffect, useState } from 'react';
// Component imporst:
import SjodirComp from '../../components/Sjodir/Sjodir';
// Type imports:
import { IDefaultProps } from '../../types/Types';
// Context imports:
import AccessTokenContextProvider, { AccessTokenContext } from '../../contexts/AccessTokenContext';

const SjodirWrapper = () => {
    const accessToken = useContext(AccessTokenContext);
    const [ defaultProps, setDefaultProps ] = useState<IDefaultProps>({
        accessToken,
        refreshRateMs: 20*1000
    });

    useEffect(() => {
        setDefaultProps({
            ...defaultProps,
            accessToken
        });
    }, [accessToken]);

    return (
        <SjodirComp {...defaultProps} />
    )
}

const Sjodir: React.FC = () => {
    return (
        <AccessTokenContextProvider>
            <SjodirWrapper />
        </AccessTokenContextProvider>
    );
}

export default Sjodir;